import { useAuth } from "../../../utils/auth";

import { useNavigate } from "@tanstack/react-router";

import { useQuery } from "@tanstack/react-query";
import { selectProfileByIdQueryOptions } from "../../profile/api/selectProfile";

const useNavigateOnboardingOrProfile = () => {
	const auth = useAuth();
	const { data: profile } = useQuery(selectProfileByIdQueryOptions(auth?.id));
	const navigate = useNavigate();

	const navigateNext = () => {
		if (!auth?.id) {
			navigate({ to: "/authenticate" });
		} else if (profile?.first_name) {
			navigate({ to: "/profile" });
		} else {
			navigate({ to: "/onboarding/welcome" });
		}
	};

	return navigateNext;
};

export default useNavigateOnboardingOrProfile;
